import { getGlobalStyles, GridContainer, GridProvider, StickyBarProvider } from '@bob/library'
import { SimpleTopbar } from '@websrc/App/Components/SimpleTopbar/SimpleTobbar'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import React from 'react'
import { Helmet } from 'react-helmet'

import * as SC from './ErrorPage.style'

export interface ErrorPageProps {
  resetError(): void
}

export const ErrorPage = ({ resetError }: ErrorPageProps) => {
  const t = useStaticText()

  return (
    <>
      <Helmet>
        <style type={'text/css'}>{getGlobalStyles()}</style>
      </Helmet>
      <StickyBarProvider>
        <GridProvider>
          <SimpleTopbar />
          <GridContainer>
            <SC.Content tablet={6} tabletOffset={3}>
              <SC.Title>{t.handle_crash_error.crash_title}</SC.Title>
              <SC.Description>{t.handle_crash_error.crash_description}</SC.Description>
              <SC.Button onClick={resetError}>{t.handle_crash_error.try_again}</SC.Button>
            </SC.Content>
          </GridContainer>
        </GridProvider>
      </StickyBarProvider>
    </>
  )
}
